import styled from 'styled-components';

export const MyAccountContainer = styled.div`
  background-color: #f8f8f8;
  padding-top: 32px;
  height: 100vh;

  .InfoHeading {
    margin: auto 12px;
    font-family: Montserrat;
    font-weight: 600;
    letter-spacing: normal;
    text-align: left;
    color: #2c2d2e;
  }

  .Log-out {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 30px auto;
    padding: 9px 60px;
    border: solid #d25240;
    border-radius: 26.3px;
    background-color: #d25240;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
  }
`;

export const AccountInfoContainer = styled.div`
  background-color: #fff;
  border-radius: 8px;
  margin: 12px 12px 14px;
  padding: 12px 16px 11px;

  .AccountInfo {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0 3px 14px 0px;
  }

  .infoPath {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-left: auto;
  }
  p {
    line-height: 1.36;
    color: #2c2d2e;
    margin: 0 0 0 12px;
    font-family: Montserrat;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 15px 14px 13px;

  img {
    margin: 20px 15px 22px 0px;
    background-color: #d9d9d9;
    border-radius: 50%;
  }

  .username {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: Montserrat;
    color: #2c2d2e;
    font-weight: bold;
  }

  h3 {
    margin: 0px;
  }

  p {
    font-size: 14px;
    font-weight: 300;
    margin: 6px auto;
  }
`;
